



import { toast } from "react-toastify";
import CustomTable from "../../../components/customTable/CustomTable";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { createMRTColumnHelper } from "material-react-table";
import ToastComponent from "../../../components/customTable/ToastComponent";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { inactiveClientApi } from "../../../app/slices/reports/inactiveClientSlice";
import NameDateSearchComponent from "../../../components/customTable/NameDateSearchComponent";

export default function InactiveClients() {
  const dispatch = useDispatch();

  const sliceResponse = useSelector((state) => state.inactiveClient.inactiveClient.data);
  const stateLoading = useSelector(
    (state) => state.inactiveClient.loading
  );
  // console.log("sliceResponse: inactiveClient", sliceResponse);

  // const fetchData = useCallback(() => {
  //   if (!sliceResponse) {
  //     dispatch(inactiveClientApi());
  //   }
  // }, [dispatch, sliceResponse]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchData = useCallback(() => {
    let params = {};
    params.name = queryParams.customerName;
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    if (Object.keys(params).length > 0) {
      dispatch(inactiveClientApi(params)); // Dispatch API call even when reset (empty search term or date)
    }
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchByDate = (startDate, endDate, customerName) => {
    setQueryParams({ startDate, endDate, customerName });
  };


  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: ({ cell }) => <div style={{ textAlign: "center" }}>{cell.row.original?.name || "N/A"}</div>,
    }),
    columnHelper.accessor("Email", {
      header: "Email",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.Email || "N/A"}</div>,
    }),
    columnHelper.accessor("mobileNo", {
      header: "Mobile No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.mobileNo || "N/A"}</div>,
    }),
    columnHelper.accessor("PanNumber", {
      header: "PAN Number",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.PanNumber || "N/A"}</div>,
    }),
    columnHelper.accessor("dob", {
      header: "Date of Birth",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.dob || "N/A"}</div>,
    }),
    columnHelper.accessor("address_line_1", {
      header: "Address Line 1",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.address_line_1 || "N/A"}</div>,
    }),
    columnHelper.accessor("address_line_2", {
      header: "Address Line 2",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.address_line_2 || "N/A"}</div>,
    }),
    columnHelper.accessor("state", {
      header: "State",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.state || "N/A"}</div>,
    }),
    columnHelper.accessor("city", {
      header: "City",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.city || "N/A"}</div>,
    }),
    columnHelper.accessor("zip", {
      header: "Zip Code",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.zip || "N/A"}</div>,
    }),
    columnHelper.accessor("bank_account_no", {
      header: "Bank Account No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.bank_account_no || "N/A"}</div>,
    }),
    columnHelper.accessor("bank_account_name", {
      header: "Bank Account Name",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.bank_account_name || "N/A"}</div>,
    }),
    columnHelper.accessor("ifsc_code", {
      header: "IFSC Code",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.ifsc_code || "N/A"}</div>,
    }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.customerRefNo || "N/A"}</div>,
    }),
    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.flag || "N/A"}</div>,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => (
        <div>{cell.row.original?.status === 0 ? "Inactive" : "Active"}</div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {cell.row.original?.createdAt
            ? new Date(cell.row.original.createdAt).toLocaleDateString()
            : "N/A"}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {cell.row.original?.updatedAt
            ? new Date(cell.row.original.updatedAt).toLocaleDateString()
            : "N/A"}
        </div>
      ),
    }),
  ];



  return (
    <>  
       {/*  */}
      <NameDateSearchComponent onSearch={handleSearchByDate} />
<Box mt={2}>

      <CustomTable columns={columns} data={sliceResponse}   
      loading={stateLoading}
      permissionKey="InactiveClient"
      />
      </Box>

    </>
  )
}
